import { render } from "./leads-board.vue?vue&type=template&id=8ec54864"
import script from "./leads-board.vue?vue&type=script&lang=js"
export * from "./leads-board.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__